import { Participacion, ParticipacionCount, RolPersona, Solicitud } from '../formalizacion-client';

export default class SolicitudImpl {
  public static getParticipacionByRol(solicitud: Solicitud, rol: RolPersona): Participacion {
    return solicitud.participaciones.find(p => {
      if (p.rolPersona === rol) {
        return p;
      }
    });
  }

  public static isResponsableOrRepresentante(participaciones: Array<ParticipacionCount>, rolSelected: string = null): boolean {
    for (const participacion of participaciones) {
      if (
        (participacion.rolPersona === RolPersona.RESPONSABLE_ADMINISTRATIVO ||
          participacion.rolPersona === RolPersona.REPRESENTANTE_LEGAL) &&
        (!rolSelected || rolSelected === RolPersona.RESPONSABLE_ADMINISTRATIVO || rolSelected === RolPersona.REPRESENTANTE_LEGAL) &&
        participacion.numero > 0
      ) {
        return true;
      }
    }
    return false;
  }

  public static isAsistido(participaciones: Array<ParticipacionCount>, rolSelected: string = null): boolean {
    for (const participacion of participaciones) {
      if (
        participacion.rolPersona === RolPersona.ASISTIDO &&
        (!rolSelected || rolSelected === RolPersona.ASISTIDO) &&
        participacion.numero > 0
      ) {
        return true;
      }
    }
    return false;
  }

  public static isExternoFondosBandeja(participaciones: Array<ParticipacionCount>, rolSelected: string = null): boolean {
    for (const participacion of participaciones) {
      if (this.isResponsableOrRepresentante([participacion], rolSelected) || this.isAsistido([participacion], rolSelected)) {
        return true;
      }
    }
    return false;
  }

  public static isResponsableOrRepresentanteByRole(rolPersona: string = null): boolean {
    return (
      rolPersona === RolPersona.ASISTIDO ||
      rolPersona === RolPersona.RESPONSABLE_ADMINISTRATIVO ||
      rolPersona === RolPersona.REPRESENTANTE_LEGAL
    );
  }

  public static isSolicitante(participaciones: Array<ParticipacionCount>): boolean {
    for (const participacion of participaciones) {
      if (
        (participacion.rolPersona === RolPersona.RESPONSABLE_PROYECTO ||
          participacion.rolPersona === RolPersona.RESPONSABLE_TECNICO ||
          participacion.rolPersona === RolPersona.ASPIRANTE) &&
        participacion.numero > 0
      ) {
        return true;
      }
    }
    return false;
  }

  public static isAsesorProyecto(participaciones: Array<ParticipacionCount>, rolSelected: string = null): boolean {
    for (const participacion of participaciones) {
      if (
        participacion.rolPersona === RolPersona.ASESOR_PROYECTO &&
        (!rolSelected || rolSelected === RolPersona.ASESOR_PROYECTO) &&
        participacion.numero > 0
      ) {
        return true;
      }
    }
    return false;
  }

  public static isExternoBecasBandeja(participaciones: Array<ParticipacionCount>, rolSelected: string = null): boolean {
    for (const participacion of participaciones) {
      if (this.isAsesorProyecto([participacion], rolSelected)) {
        return true;
      }
    }
    return false;
  }

  public static isExternoFondos(participaciones: Array<ParticipacionCount>): boolean {
    for (const participacion of participaciones) {
      if (this.isResponsableTecnico([participacion]) || this.isExternoFondosBandeja([participacion])) {
        return true;
      }
    }
    return false;
  }

  public static isResponsableTecnico(participaciones: Array<ParticipacionCount>): boolean {
    for (const participacion of participaciones) {
      if (
        (participacion.rolPersona === RolPersona.RESPONSABLE_PROYECTO || participacion.rolPersona === RolPersona.RESPONSABLE_TECNICO) &&
        participacion.numero > 0
      ) {
        return true;
      }
    }
    return false;
  }

  public static isResponsableProyecto(participaciones: Array<ParticipacionCount>): boolean {
    for (const participacion of participaciones) {
      if (participacion.rolPersona === RolPersona.RESPONSABLE_PROYECTO && participacion.numero > 0) {
        return true;
      }
    }
    return false;
  }

  public static isAspirante(participaciones: Array<ParticipacionCount>): boolean {
    for (const participacion of participaciones) {
      if (participacion.rolPersona === RolPersona.ASPIRANTE && participacion.numero > 0) {
        return true;
      }
    }
    return false;
  }

  public static isResponsableTecnicoP(participaciones: Array<ParticipacionCount>): boolean {
    for (const participacion of participaciones) {
      if (participacion.rolPersona === RolPersona.RESPONSABLE_TECNICO && participacion.numero > 0) {
        return true;
      }
    }
    return false;
  }

  public static isExternoSNI(participaciones: Array<ParticipacionCount>, rolSelected: string = null): boolean {
    for (const participacion of participaciones) {
      if (
        (participacion.rolPersona === RolPersona.SOLICITANTE ||
          participacion.rolPersona === RolPersona.AYUDANTE ||
          participacion.rolPersona === RolPersona.AUTORIDAD_FACULTADA_EXTERNA) &&
        (!rolSelected ||
          rolSelected === RolPersona.AYUDANTE ||
          rolSelected === RolPersona.SOLICITANTE ||
          rolSelected === RolPersona.AUTORIDAD_FACULTADA_EXTERNA) &&
        participacion.numero > 0
      ) {
        return true;
      }
    }
    return false;
  }

  public static isExternoBandeja(participaciones: Array<ParticipacionCount>, rolSelected: string = null): boolean {
    for (const participacion of participaciones) {
      if (
        this.isExternoBecasBandeja([participacion], rolSelected) ||
        this.isExternoFondosBandeja([participacion], rolSelected) ||
        this.isExternoSNI([participacion], rolSelected)
      ) {
        return true;
      }
    }
    return false;
  }

  public static isSolicitanteSNI(participaciones: Array<ParticipacionCount>): boolean {
    for (const participacion of participaciones) {
      if (participacion.rolPersona === RolPersona.SOLICITANTE && participacion.numero > 0) {
        return true;
      }
    }
    return participaciones.length > 0;
  }

  public static isAyudanteSNI(participaciones: Array<ParticipacionCount>, rolSelected: string = null): boolean {
    for (const participacion of participaciones) {
      if (
        participacion.rolPersona === RolPersona.AYUDANTE &&
        (!rolSelected || rolSelected === RolPersona.AYUDANTE) &&
        participacion.numero > 0
      ) {
        return true;
      }
    }
    return false;
  }

  public static getRolesExternosBandeja(participaciones: Array<ParticipacionCount>): Array<RolPersona> {
    return participaciones
      .map(participacion => {
        if (
          this.isExternoSNI([participacion]) ||
          this.isExternoFondosBandeja([participacion]) ||
          this.isAsesorProyecto([participacion]) ||
          this.isAspirante([participacion])
        ) {
          return participacion.rolPersona;
        }
      })
      .filter(notUndefined => notUndefined !== undefined);
  }

  public static isAutoridadFacultadaExterna(participaciones: Array<ParticipacionCount>): boolean {
    for (const participacion of participaciones) {
      if (participacion.rolPersona === RolPersona.AUTORIDAD_FACULTADA_EXTERNA && participacion.numero > 0) {
        return true;
      }
    }
    return false;
  }

  public static isRoleAutoridadFacultadaExternaSelected(participaciones: Array<ParticipacionCount>, rolSelected: String): boolean {
    return rolSelected && rolSelected === RolPersona.AUTORIDAD_FACULTADA_EXTERNA && this.isAutoridadFacultadaExterna(participaciones);
  }

  public static isComprobanteAcreditaciones(procesoClave: string): boolean {
    return procesoClave === 'SNI-ACRED-2023' || procesoClave === 'SNI-ACRED-SIN-INST-2023' || procesoClave === 'SNI-ACRED-EXT-2023';
  }

  public static isInformeAcreditaciones(procesoClave: string): boolean {
    return (
      procesoClave === 'SNI-ACRED-INFORME-2023' ||
      procesoClave === 'SNI-ACRED-INFORME-SIN-INST-2023' ||
      procesoClave === 'SNI-ACRED-INFORME-EXT-2023'
    );
  }

  public static isProcesoAyudantes(procesoClave: string): boolean {
    const procesosClaves = [
      'SNI-AYUD-ALTA-2023',
      'SNI-AYUD-RCLS-2023',
      'SNI-AYUD-BSNI-2023',
      'SNI-AYUD-BAYU-2023',
      'SNI-AYUD-BCON-2023',
      'SNI-AYUD-BMAC-2023',
      'SNI-AYUD-ALTA-2024',
      'SNI-AYUD-ALTA-2024V2',
      'SNI-AYUD-ALTA-2024V3',
      'SNI-AYUD-RCLS-2024',
      'SNI-AYUD-RCLS-2024V2',
      'SNI-AYUD-RCLS-2024V3',
      'SNI-AYUD-BSNI-2024',
      'SNI-AYUD-BSNI-2024V2',
      'SNI-AYUD-BSNI-2024V3',
      'SNI-AYUD-BAYU-2024',
      'SNI-AYUD-BAYU-2024V2',
      'SNI-AYUD-BAYU-2024V3',
      'SNI-AYUD-BCON-2024',
      'SNI-AYUD-BCON-2024V2',
      'SNI-AYUD-BMAC-2024',
      'SNI-AYUD-BMAC-2024V2',
      'SNI-AYUD-BMAC-2024V3',
    ];

    return procesosClaves.includes(procesoClave);
  }

  public static isOficioReconocimiento(procesoClave: string): boolean {
    const procesosClave = [
      'SNI-RECON-OFI-2023',
      'SNI-RECON-OFM-2023',
      'SNI-RECON-EMER-OFI-2023',
      'SNI-RECON-EMER-OFIM-2023',
      'SNI-RECON-RECONSID-OFI-2023',
      'SNI-RECON-RECONSID-OFIM-2023',
      'SNI-RECON-OFI-2024',
      'SNI-RECON-OFM-2024',
      'SNI-RECON-EMER-OFI-2024',
      'SNI-RECON-EMER-OFIM-2024',
      'SNI-RECON-RECONSID-OFI-2024',
      'SNI-RECON-RECONSID-OFIM-2024',
    ];
    return procesosClave.includes(procesoClave);
  }

  public static isReconocimiento(procesoClave: string): boolean {
    const procesosClave = ['SNI-RECON-REC-2023', 'SNI-RECON-EMER-REC-2023', 'SNI-RECON-REC-2024', 'SNI-RECON-EMER-REC-2024'];
    return procesosClave.includes(procesoClave);
  }

  public static isConvenioIngreso(procesoClave: string): boolean {
    const procesosClave = ['SNI-RECON-CON-2023', 'SNI-RECON-CON-2024', 'SNI-RECON-CON-EMER-2024'];
    return procesosClave.includes(procesoClave);
  }

  public static isProcesoAcreditaciones(procesoClave: string): boolean {
    return this.isComprobanteAcreditaciones(procesoClave) || this.isInformeAcreditaciones(procesoClave);
  }

  public static isProcesoReconocimientos(procesoClave: string): boolean {
    return this.isOficioReconocimiento(procesoClave) || this.isReconocimiento(procesoClave) || this.isConvenioIngreso(procesoClave);
  }

  public static isVigencia(procesoClave: string): boolean {
    const procesosClave = [
      'SNI-MOV-VIG-EX',
      'SNI-VIG-EX-FALLECIMIENTO',
      'SNI-MOV-VIG-EX-2024',
      'SNI-VIG-EX-FALLECIMIENTO-2024',
      'SNI-MOV-VIG-EX-REC-2024-2',
    ];
    return procesosClave.includes(procesoClave);
  }

  public static isVigenciaCon(procesoClave: string): boolean {
    const procesosClave = ['SNI-MOV-VIG-EX-CONV-2024-2', 'SNI-MOV-VIG-EX-CONV-2024-2V2', 'SNI-MOV-VIG-EX-CONV-2024-2V3'];
    return procesosClave.includes(procesoClave);
  }

  public static isProcesoSNI(procesoClave: string): boolean {
    return (
      this.isProcesoAcreditaciones(procesoClave) ||
      this.isProcesoAyudantes(procesoClave) ||
      this.isProcesoReconocimientos(procesoClave) ||
      this.isVigencia(procesoClave) ||
      this.isVigenciaCon(procesoClave)
    );
  }

  public static isRenovacionesAdenda(modalidadClave: string): boolean {
    return (
      modalidadClave === 'RENOVACIONES-2023' ||
      modalidadClave === 'BPR-PPA-2023' ||
      modalidadClave === 'BPR-PPI-2023' ||
      modalidadClave === 'BPR-PPA-2024' ||
      modalidadClave === 'BPR-PPI-2024' ||
      modalidadClave === 'BPR-PPA-2024V2' ||
      modalidadClave === 'BPR-PPI-2024V2' ||
      modalidadClave === 'BPR-PPA-2025' ||
      modalidadClave === 'BPR-PPI-2025' ||
      modalidadClave === 'BPMR-PPA-2023' ||
      modalidadClave === 'BPMR-PPI-2023' ||
      modalidadClave === 'BPR-PSA-2022' ||
      modalidadClave === 'BPR-PSI-2022' ||
      modalidadClave === 'BPR-PAC3-2022' ||
      modalidadClave === 'BPR-PIC3-2022' ||
      modalidadClave === 'BPR-PAI3-2022' ||
      modalidadClave === 'BPR-PII3-2022' ||
      modalidadClave === 'BPR-PAIXM-2022' ||
      modalidadClave === 'BPR-PIIXM-2022' ||
      modalidadClave === 'BPR-PPA-2023V2' ||
      modalidadClave === 'BPR-PPI-2023V2' ||
      modalidadClave === 'BPR-PPA-2022' ||
      modalidadClave === 'BPR-PPI-2022' ||
      modalidadClave === 'BPMR-PPA-2022' ||
      modalidadClave === 'BPMR-PPI-2022' ||
      modalidadClave === 'BPR-PSA-2022V2'
    );
  }

  public static isBecaNacional(modalidadClave: string): boolean {
    const modalidadClaves = [
      'BECAS-NAC-CAB-2023',
      'BECAS-REZAGOSOC-2023',
      'BECAS-ESP-SALUD-2023',
      'BECAS-HCCONDUCTA-2023',
      'BECAS-NAC-CAB-2024-1',
      'BECAS-ESP-MED-CAB-2024',
      'BECAS-REZAGOSOC-2024-1',
      'BECAS-ESP-SALUD-2024-1',
      'BECAS-HCCONDUCTA-2024-1',
      'BECAS-NAC-CAB-2024-2',
      'BECAS-REZAGOSOC-2024-2',
      'BECAS-ESP-SALUD-2024-2',
      'BECAS-HCCONDUCTA-2024-2',
      'BECAS-CIBNOR-2024-1',
      'BECAS-INAH-2024-1',
      'BECAS-ECOSUR-2024-1',
      'BECAS-NAC-CAB-2025-1',
      'BECAS-REZAGOSOC-2025-1',
      'BECAS-ESP-SALUD-2025-1',
      'BECAS-HCCONDUCTA-2025-1',
      'BECAS-ESP-MED-CAB-2025-1',
      'BECAS-ESP-MED-NAC-2025-1',
      'BECAS-FM-2025-1',
      'BECAS-CIBNOR-2025-1',
      'BECAS-INAH-2025-1',
      'BECAS-ECOSUR-2025-1',
    ];
    return modalidadClaves.includes(modalidadClave);
  }

  public static isBecaExtranjera(modalidadClave: string): boolean {
    return this.isBecaExtranjeraAnexo(modalidadClave) || this.isBecaExtranjeraConvenio(modalidadClave);
  }

  public static isBecaExtranjeraAnexo(modalidadClave: string): boolean {
    const modalidadClaves = [
      'BEXT-ANEX-CUBA2024',
      'BEXT-ANEX-CYH2024',
      'BEXT-ANEX-ESPMED2024',
      'BEXT-ANEX-ESPMED2024-2',
      'BEXT-ANEX-CREACON-FUTURO2024',
    ];
    return modalidadClaves.includes(modalidadClave);
  }

  public static isBecaExtranjeraConvenio(modalidadClave: string): boolean {
    const modalidadClaves = [
      'BEXT-CONV-CUBA2024',
      'BEXT-CONV-CYH2024',
      'BEXT-CONV-ESPMED2024',
      'BEXT-CONV-ESPMED2024-2',
      'BEXT-CONV-CREACON-FUTURO2024',
    ];
    return modalidadClaves.includes(modalidadClave);
  }

  public static isMMJFAdenda(modalidadClave): boolean {
    return modalidadClave === 'BPM-MMJF-ADENDA-2023';
  }

  public static isFondos(modalidadClave: string): boolean {
    const modalidadClaves = [
      'CF-2023-G',
      'CF-MG-2019',
      'CF-MI-2019',
      'CF-2023-I',
      'CF-MS-2019',
      'CF-2023-2-I',
      'CF-2023-2-G',
      'CF-2023-2A-I',
      'CF-2023-2A-G',
      'CBF-2023-2024',
    ];
    return modalidadClaves.includes(modalidadClave);
  }

  public static isPronaces(modalidadClave: string): boolean {
    const modalidadClaves = [
      'CDS-2019',
      'SM-M2-2019',
      'SM-M5D5_1-2019',
      'SM-M1D1_2-2019',
      'SM-M4-2019',
      'SC-2019',
      'SM-M1D1_3-2019',
      'SM-M3-2019',
      'SM-M5D5_2-2019',
    ];
    return modalidadClaves.includes(modalidadClave);
  }

  public static isProyectosPorEncargo(modalidadClave: string): boolean {
    const modalidadClaves = ['FOP18-2023', 'FOP21-2024'];
    return modalidadClaves.includes(modalidadClave);
  }

  public static isBecaSabaticas(modalidadClave: string): boolean {
    const modalidadClaves = ['BP-ES-EXT-2025', 'BP-ES-NAC-2025'];
    return modalidadClaves.includes(modalidadClave);
  }

  public static isBecaEPMExt(modalidadClave: string): boolean {
    const modalidadClaves = ['BP-EPI-EXT-2025'];
    return modalidadClaves.includes(modalidadClave);
  }

  public static isBecaSinDependientes(modalidadClave: string): boolean {
    return this.isBecaSabaticas(modalidadClave) || this.isBecaEPMExt(modalidadClave);
  }
}
